export default __webpack_public_path__ + "static/media/carret-down.62368490.svg";